import React, { lazy, Suspense } from 'react';

const LazyProjectPreview = lazy(() => import('./ProjectPreview'));

const ProjectPreview = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; } | any) => (
  <Suspense fallback={null}>
    <LazyProjectPreview {...props} />
  </Suspense>
);

export default ProjectPreview;
